import { APIClient } from "./axiosClient";

export class PlatformCategoryApi {
  static fetchCategoryTree(platformCategoryCode = "ROOT") {
    return APIClient(`/platformCategory/getPlatformCategoryTree?platformCategoryCode=${platformCategoryCode}`);
  }

  static assignProductsToPlatformCategory(payload, apiParams = {}) {
    return APIClient(
      '/platformCategory/assignProductsToPlatformCategory',
      payload,
      { requestType: 'post', ...apiParams }
    );
  }

  static createPlatformCategory(payload, apiParams = {}) {
    return APIClient(
      '/platformCategory/createPlatformCategory',
      payload,
      { requestType: 'post', ...apiParams }
    );
  }

  static deletePlatformCategory(platformCategoryId, apiParams = {}) {
    return APIClient(
      `/platformCategory/deletePlatformCategory?platformCategoryId=${platformCategoryId}`,
      {},
      { requestType: 'get', ...apiParams }
    );
  }

  static hidePlatformCategory(platformCategoryId, apiParams = {}) {
    return APIClient(
      `/platformCategory/hidePlatformCategory?platformCategoryId=${platformCategoryId}`,
      {},
      { requestType: 'get', ...apiParams }
    );
  }

  static unHidePlatformCategory(platformCategoryId, apiParams = {}) {
    return APIClient(
      `/platformCategory/unHidePlatformCategory?platformCategoryId=${platformCategoryId}`,
      {},
      { requestType: 'get', ...apiParams }
    );
  }

  static hideProgramCategory(programCategoryId, apiParams = {}) {
    return APIClient(
      `/programCategory/hideProgramCategory?programCategoryId=${programCategoryId}`,
      {},
      { requestType: 'get', ...apiParams }
    );
  }

  static unHideProgramCategory(programCategoryId, apiParams = {}) {
    return APIClient(
      `/programCategory/unHideProgramCategory?programCategoryId=${programCategoryId}`,
      {},
      { requestType: 'get', ...apiParams }
    );
  }

  static getProgramCategoryTree(programId, programCategoryCode = "ROOT", apiParams = {}) {
    return APIClient(
      `/programCategory/getProgramCategoryTree?programId=${programId}&programCategoryCode=${programCategoryCode}`,
      {},
      { requestType: 'get', ...apiParams }
    );
  }

  static createOrUpdateProgramCategory(payload, apiParams = {}) {
    return APIClient(
      '/programCategory/createOrUpdateProgramCategory',
      payload,
      { requestType: 'post', ...apiParams }
    );
  }

  static deleteProgramCategory(programCategoryId, apiParams = {}) {
    return APIClient(
      `/programCategory/deleteProgramCategory?programCategoryId=${programCategoryId}`,
      {},
      { requestType: 'get', ...apiParams }
    );
  }

  static assignProductsToProgramCategory(payload, apiParams = {}) {
    return APIClient(
      '/programCategory/assignProductsToProgramCategory',
      payload,
      { requestType: 'post', ...apiParams }
    );
  }

  static unAssignProductsFromProgramCategory(payload, apiParams = {}) {
    return APIClient(
      '/programCategory/unAssignProductsFromProgramCategory',
      payload,
      { requestType: 'post', ...apiParams }
    );
  }
} 